import style from '../assets/complianceStyle';
import logo from '../assets/compliassistlogob64';
import sanitize from '../utils/sanitize';
import { generateFooterTemplate, generateHeaderTemplate } from './headerFooter';

const HTML_TEMPLATES = {
  bendData: (formattedCharts, formattedChartsByState, searchCriteria, groupBy) => {
    const { Categories, Charts, States, SearchText } = searchCriteria;
    return `
      <section class="apcia-white-Section-section">
        <div class="apcia-container-lg-Container">
          <section class="apcia-logo">
            <img src="${logo}" alt="Compliassist logo">
          </section>
          <div>
            <div>
              <div class="apcia-container">
                <div class="apcia-headingWrapper">
                  <h4 class="apcia-4-bolder-primaryGray-Heading-heading">Search Criteria</h4>
                </div>
                <div class="apcia-dataRow">
                  <p class="apcia-label-SearchCriteria">Category:</p>
                  <p class="apcia-data">${Categories.map(c => c.CategoryDescription).join(', ')}</p>
                </div>
                <div class="apcia-dataRow">
                  <p class="apcia-label-SearchCriteria">Chart(s):</p>
                  <p class="apcia-data">${Charts.map(c => c.ChartDescription).join(', ')}</p>
                </div>
                <div class="apcia-dataRow">
                  <p class="apcia-label-SearchCriteria">State(s):</p>
                  <p class="apcia-data">${
                    States.length > 0
                      ? States.map(c => c.StateDescription).join(', ')
                      : 'All States'
                  }</p>
                </div>
                <div class="apcia-dataRow">
                  <p class="apcia-label-SearchCriteria">Search Text:</p>
                  <p class="apcia-data">${SearchText}</p>
                </div>
              </div>
              ${
                groupBy === 'state'
                  ? `<div>
                  <div>
                    ${formattedCharts
                      .map(
                        chart =>
                          `<div class="apcia-1fygsgo">
                        <div>
                          <div class="apcia-container">
                            <div class="apcia-gridContainer">
                              <p class="apcia-label">Chart Name:</p>
                              <div class="apcia-data">${chart.ChartTitle}</div>
                            </div>
                            <div class="apcia-gridContainer">
                              <p class="apcia-label">Chart Description:</p>
                              <div class="apcia-data">${chart.ChartDescription}</div>
                            </div>
                            <div class="apcia-gridContainer">
                              <p class="apcia-label">Chart Notes:</p>
                              <div class="apcia-data">
                                <div class="sanitized">
                                  ${sanitize(chart.ChartNotes)}
                                </div>
                              </div>
                            </div>
                            <div class="apcia-1fygsgo">
                              <div class="apcia-gridContainer">
                                <p class="apcia-label">Contact:</p>
                                <div class="apcia-data">
                                  <div>
                                    <p class="apcia-data">${chart.Contact.FullName}</p>
                                    <p class="apcia-data">${chart.Contact.Phone}</p>
                                    <a href="mailto:${
                                      chart.Contact.EmailAddress
                                    }" class="apcia-4-bold-primaryBlue-Heading-data">${
                            chart.Contact.EmailAddress
                          }</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>`
                      )
                      .join('')}
                  </div>
                  <div>
                  ${formattedChartsByState
                    .map(
                      state =>
                        `<div class="apcia-1fygsgo">
                      <div class="apcia-container">
                        <div class="apcia-headingWrapper">
                          <h4 class="apcia-4-bolder-primaryGray-Heading-heading2">${
                            state.ChartState
                          }</h4>
                        </div>
                        ${state.charts
                          .map(
                            chart =>
                              `<div class="apcia-gridContainer2">
                              <p class="apcia-label">Chart Name:</p>
                              <div class="apcia-data">${chart.ChartTitle}</div>
                            </div>
                            ${chart.topics
                              .map(
                                topic => `
                              <div class="apcia-gridContainer">
                                <p>${topic.ChartTopic}</p>
                                <div class="sanitized ">${sanitize(topic.Details)}</div>
                              </div>
                            `
                              )
                              .join('')}
                            <div class="apcia-gridContainer">
                              <p>State Notes: </p>
                              <div class="sanitized ">
                                ${sanitize(
                                  chart.topics.length
                                    ? chart.topics[chart.topics.length - 1].StateNotes
                                    : ''
                                )}
                              </div>
                            </div>`
                          )
                          .join('')}
                      </div>
                    </div>`
                    )
                    .join('')}
                  </div>
                </div>`
                  : formattedCharts
                      .map(
                        chart => `
                  <div>
                    <div class="apcia-1fygsgo">
                      <div>
                        <div class="apcia-container">
                          <div class="apcia-gridContainer">
                            <p class="apcia-label">Chart Name:</p>
                            <div class="apcia-data">${chart.ChartTitle}</div>
                          </div>
                          <div class="apcia-gridContainer">
                            <p class="apcia-label">Chart Description:</p>
                            <div class="apcia-data">${chart.ChartDescription}</div>
                          </div>
                          <div class="apcia-gridContainer">
                            <p class="apcia-label">Chart Notes:</p>
                            <div class="apcia-data">
                              <div class="sanitized">
                                ${sanitize(chart.ChartNotes)}
                              </div>
                            </div>
                          </div>
                          <div class="apcia-1fygsgo">
                            <div class="apcia-gridContainer">
                              <p class="apcia-label">Contact:</p>
                              <div class="apcia-data">
                                <div>
                                  <p class="apcia-data">${chart.Contact.FullName}</p>
                                  <p class="apcia-data">${chart.Contact.Phone}</p>
                                  <a href="mailto:${
                                    chart.Contact.EmailAddress
                                  }" class="apcia-4-bold-primaryBlue-Heading-data">
                                    ${chart.Contact.EmailAddress}
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    ${chart.states
                      .map(
                        state => `
                      <div class="apcia-1fygsgo">
                        <div class="apcia-container">
                          <div class="apcia-headingWrapper">
                            <h4 class="apcia-4-bolder-primaryGray-Heading-heading">${
                              state.ChartState
                            }</h4>
                          </div>
                          ${state.topics
                            .map(
                              topic => `
                            <div class="apcia-gridContainer">
                              <p>${topic.ChartTopic}</p>
                              <div class="sanitized ">${sanitize(topic.Details)}</div>
                            </div>
                          `
                            )
                            .join('')}
                          <div class="apcia-gridContainer">
                            <p>Notes: </p>
                            <div class="sanitized ">
                              ${sanitize(
                                state.topics.length
                                  ? state.topics[state.topics.length - 1].StateNotes
                                  : ''
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    `
                      )
                      .join('')}
                  </div>
              `
                      )
                      .join('')
              }
            </div>
            <p class="apcia-text">
              <b>Disclaimer:</b> This compliance resource was prepared by American Property Casualty Insurance Association (APCIA) as a research aid only. 
              Reasonable attempts have been made to ensure that the content is accurate and current as of its publication date. However, 
              you should independently verify any statutory or regulatory language referenced herein. This compliance resource is not intended as, 
              and should not be construed to constitute, legal or regulatory advice and use of the resource(or any part thereof) does not establish an attorney / client relationship. 
              Transmission or reproduction of the compliance resource for commercial purposes or for distribution as legal or regulatory advice or using it to serve as, substitute for, 
              supplement, or replace the operating procedures, decision rules, guidelines, or advice of your Company is strictly prohibited. 
              Non - commercial transmission or reproduction of this resource for limited, internal use is permissible, but must include this Disclaimer.
            </p>
          </div>
        </div>
      </section>
    `;
  },
};

export function generateHTMLString(
  formattedCharts,
  formattedChartsByState,
  searchCriteria,
  groupBy
) {
  return `
    ${generateHeaderTemplate(style)}
    ${HTML_TEMPLATES.bendData(formattedCharts, formattedChartsByState, searchCriteria, groupBy)}
    ${generateFooterTemplate()}
  `;
}
